// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d6b8f35","453":"96b104a6","455":"f2cbb8e0","977":"4ec702f7"}[chunkId] + ".chunk.js";
};